import {Component, forwardRef, Input, OnInit, TemplateRef} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {BaseControlValueAccessor} from "../base_control_value_accessor/base";


@Component({
    selector: 'app-select-field',
    templateUrl: './select-field.component.html',
    styleUrls: ['../form-field.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => SelectFieldComponent),
        }
    ]
})

export class SelectFieldComponent extends BaseControlValueAccessor implements OnInit {

    @Input()
    options = [];

    @Input()
    displayField: string = null;

    @Input()
    idField = 'id';

    @Input()
    multiple = false;

    @Input()
    clearable = false;

    @Input()
    trim = false;

    @Input()
    customOptions: boolean = false;

    @Input()
    searchable: boolean = false;

    @Input()
    defaultChip: boolean = true;

    @Input()
    headerTemplate: TemplateRef<any> = null;

    @Input()
    footerTemplate: TemplateRef<any> = null;

    @Input()
    itemTemplate: TemplateRef<any> = null;

    @Input()
    labelItemTemplate: TemplateRef<any> = null;

    @Input()
    displayTemplate: TemplateRef<any> = null;

    // @Input()
    // getDisplay(item) {
    //   if (this.displayField == null)
    //     return item;
    //   return item[this.displayField];
    // }

    loading = false;

    constructor() {
        super();
    }

    ngOnInit(): void {

    }

    compareField(options, idField) {
        return options === idField;
    }


    // get dataId() {
    //   if (this.data == null || this.data == undefined) {
    //     return null;
    //   }
    //   if (typeof this.data == 'object' && this.idField in this.data) {
    //     return this.data[this.idField]
    //   }
    //   return null;
    // }

    // getObjectById(id) {
    //   let candidateObjs = this.options.filter(item => item[this.idField] == id);
    //   if (candidateObjs.length == 1) {
    //     return candidateObjs[0];
    //   }
    //   else if (candidateObjs.length > 1) {
    //     console.error(`Multiple object with same id field found!!!`);
    //   } else {
    //     console.error(`No object with id field found!!!`);

    //   }
    //   return null;
    // }

    // setData(id) {
    //   this.data = this.getObjectById(id);
    // }


    getDisplay() {
        if (this.data == null || this.data == undefined) {
            return '-';
        }

        if (typeof this.data == 'object') {
            if (this.displayField in this.data) {
                return this.data[this.displayField];
            }
        } else {
            return this.data;
        }
    }

    isItemSelected(item): boolean {
        let ids = [];
        if (this.data != null) {
            this.data.map(data => ids.push(data.id));
            return ids.includes(item.id);
        }
    }

    displayItem(item) {
        if (item == null) {
            return '-';
        }

        if (typeof item == 'object') {
            if (this.displayField in item) {
                return item[this.displayField];
            }
        } else {
            return item
        }
    }

}

